import type { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export type AlertProps = ComponentProps<"p"> & VariantProps<typeof alertStyles>;

export function AlertBar2({ children, className, variant }: AlertProps) {
  const { body } = alertStyles({ variant });

  return (
    <p role="alert" className={cn(body(), className)}>
      {children}
    </p>
  );
}

const alertStyles = tv({
  slots: {
    body: "tw:px-3 tw:py-2.5 tw:rounded-lg tw:text-sm tw:border",
  },
  variants: {
    variant: {
      error: {
        body: "tw:border-stroke-error-secondary tw:bg-fill-error-tertiary  tw:text-text-error-primary",
      },
      success: {
        body: "tw:border-stroke-success-secondary tw:bg-fill-success-tertiary  tw:text-text-success-primary",
      },
      warning: {
        body: "tw:border-stroke-warning-primary tw:bg-fill-warning-tertiary tw:text-text-warning",
      },
    },
  },
});
